// Mock data for the Uber clone

export const mockUser = {
  id: '1',
  name: 'John Doe',
  email: 'john@example.com',
  phone: '+963-123-456789',
  role: 'passenger',
  rating: 4.8,
  totalRides: 45,
  profileImage: 'https://ui-avatars.com/api/?name=John+Doe&background=4f46e5&color=fff'
};

export const mockDriver = {
  id: 'd1',
  name: 'Ahmed Ali',
  email: 'ahmed@example.com',
  phone: '+963-987-654321',
  role: 'driver',
  rating: 4.9,
  totalRides: 1250,
  carModel: 'Toyota Corolla 2020',
  carNumber: 'DMS 1234',
  earnings: {
    today: 25000,
    week: 150000,
    month: 580000
  },
  isOnline: true,
  location: [33.5138, 36.2765], // Damascus coordinates
  profileImage: 'https://ui-avatars.com/api/?name=Ahmed+Ali&background=10b981&color=fff'
};

export const mockRides = [
  {
    id: 'r1',
    passengerId: '1',
    driverId: 'd1',
    passengerName: 'John Doe',
    driverName: 'Ahmed Ali',
    pickup: { lat: 33.5138, lng: 36.2765, address: 'Damascus City Center' },
    dropoff: { lat: 33.5102, lng: 36.2913, address: 'Damascus University' },
    status: 'completed',
    carType: 'economy',
    fare: 5000,
    distance: '5.2 km',
    duration: '15 min',
    date: '2025-07-15T10:30:00',
    rating: 5,
    paymentMethod: 'cash'
  },
  {
    id: 'r2',
    passengerId: '1',
    driverId: 'd2',
    passengerName: 'John Doe',
    driverName: 'Omar Hassan',
    pickup: { lat: 33.5138, lng: 36.2765, address: 'Umayyad Square' },
    dropoff: { lat: 33.5021, lng: 36.3026, address: 'Damascus Airport' },
    status: 'completed',
    carType: 'comfort',
    fare: 15000,
    distance: '12.8 km',
    duration: '25 min',
    date: '2025-07-14T14:20:00',
    rating: 4,
    paymentMethod: 'card'
  },
  {
    id: 'r3',
    passengerId: '1',
    driverId: 'd3',
    passengerName: 'John Doe',
    driverName: 'Khaled Ibrahim',
    pickup: { lat: 33.5138, lng: 36.2765, address: 'Old Damascus' },
    dropoff: { lat: 33.5234, lng: 36.2893, address: 'Al-Hamidiyah Souq' },
    status: 'completed',
    carType: 'economy',
    fare: 3000,
    distance: '2.1 km',
    duration: '8 min',
    date: '2025-07-13T09:15:00',
    rating: 5,
    paymentMethod: 'cash'
  }
];

export const mockCarTypes = [
  {
    id: 'economy',
    name: 'Economy',
    nameAr: 'اقتصادي',
    description: 'Affordable rides',
    descriptionAr: 'رحلات بأسعار معقولة',
    pricePerKm: 500,
    baseFare: 2000,
    eta: '3 min',
    icon: '🚗',
    capacity: 4
  },
  {
    id: 'comfort',
    name: 'Comfort',
    nameAr: 'مريح',
    description: 'More space and comfort',
    descriptionAr: 'مساحة وراحة أكثر',
    pricePerKm: 800,
    baseFare: 3000,
    eta: '5 min',
    icon: '🚙',
    capacity: 4
  },
  {
    id: 'premium',
    name: 'Premium',
    nameAr: 'فاخر',
    description: 'Luxury vehicles',
    descriptionAr: 'سيارات فاخرة',
    pricePerKm: 1200,
    baseFare: 5000,
    eta: '8 min',
    icon: '🚘',
    capacity: 4
  }
];

export const mockDrivers = [
  {
    id: 'd1',
    name: 'Ahmed Ali',
    phone: '+963-987-654321',
    email: 'ahmed@example.com',
    rating: 4.9,
    totalRides: 1250,
    status: 'online',
    carModel: 'Toyota Corolla 2020',
    carNumber: 'DMS 1234',
    verified: true,
    earnings: 580000,
    location: [33.5138, 36.2765]
  },
  {
    id: 'd2',
    name: 'Omar Hassan',
    phone: '+963-987-654322',
    email: 'omar@example.com',
    rating: 4.7,
    totalRides: 890,
    status: 'online',
    carModel: 'Hyundai Elantra 2019',
    carNumber: 'DMS 5678',
    verified: true,
    earnings: 420000,
    location: [33.5102, 36.2913]
  },
  {
    id: 'd3',
    name: 'Khaled Ibrahim',
    phone: '+963-987-654323',
    email: 'khaled@example.com',
    rating: 4.8,
    totalRides: 675,
    status: 'offline',
    carModel: 'Kia Cerato 2021',
    carNumber: 'DMS 9012',
    verified: true,
    earnings: 320000,
    location: [33.5021, 36.3026]
  }
];

export const mockPassengers = [
  {
    id: 'p1',
    name: 'John Doe',
    phone: '+963-123-456789',
    email: 'john@example.com',
    rating: 4.8,
    totalRides: 45,
    status: 'active',
    joinDate: '2024-01-15'
  },
  {
    id: 'p2',
    name: 'Sarah Smith',
    phone: '+963-123-456790',
    email: 'sarah@example.com',
    rating: 4.9,
    totalRides: 67,
    status: 'active',
    joinDate: '2024-02-20'
  },
  {
    id: 'p3',
    name: 'Ali Mohammad',
    phone: '+963-123-456791',
    email: 'ali@example.com',
    rating: 4.6,
    totalRides: 32,
    status: 'active',
    joinDate: '2024-03-10'
  }
];

export const mockAdminStats = {
  totalUsers: 15420,
  activeDrivers: 856,
  activeRides: 127,
  todayRevenue: 2350000,
  weekRevenue: 15680000,
  monthRevenue: 58900000,
  totalRides: 45678,
  completedToday: 1234,
  averageRating: 4.8
};

export const mockLocations = [
  { name: 'Damascus City Center', nameAr: 'وسط دمشق', lat: 33.5138, lng: 36.2765 },
  { name: 'Damascus University', nameAr: 'جامعة دمشق', lat: 33.5102, lng: 36.2913 },
  { name: 'Umayyad Square', nameAr: 'ساحة الأمويين', lat: 33.5138, lng: 36.2765 },
  { name: 'Damascus Airport', nameAr: 'مطار دمشق', lat: 33.4115, lng: 36.5144 },
  { name: 'Old Damascus', nameAr: 'دمشق القديمة', lat: 33.5121, lng: 36.3066 },
  { name: 'Al-Hamidiyah Souq', nameAr: 'سوق الحميدية', lat: 33.5115, lng: 36.3070 },
  { name: 'Aleppo City Center', nameAr: 'وسط حلب', lat: 36.2021, lng: 37.1343 },
  { name: 'Aleppo Citadel', nameAr: 'قلعة حلب', lat: 36.1989, lng: 37.1612 },
  { name: 'Homs City', nameAr: 'مدينة حمص', lat: 34.7298, lng: 36.7167 },
  { name: 'Lattakia Corniche', nameAr: 'كورنيش اللاذقية', lat: 35.5185, lng: 35.7753 }
];